import { DragEvent, useState } from 'react'
import { useContext, useContextSelector } from 'use-context-selector'

import { PromoPageStateContext } from 'states/PromoPageState/PromoPageStateProvider'
import { saveSection } from 'states/PromoPageState/reducer'
import { SectionState } from 'states/PromoPageState/state'
import { BlockWrap } from 'components/AdminV2/BlockWrap/BlockWrap'
import { AdminAddElemButton } from 'components/AdminV2/UI/AddElemButton/AdminAddElemButton'
import { AdminElemVisibilityToggle } from 'components/AdminV2/UI/ElemVisibilityToggle/AdminElemVisibilityToggle'
import { AdminInput } from 'components/AdminV2/UI/Input/AdminInput'
import { AdminSaveButton } from 'components/AdminV2/UI/SaveButton/AdminSaveButton'
import { FaqData, SectionName } from 'types/types'

import { FaqEl } from './FaqEl/FaqEl'

import s from './FaqBlock.module.scss'

export const FaqBlock = () => {
  const state = useContextSelector(PromoPageStateContext, (context) =>
    context.state.sections.find((section) => section.type === 'Faq'),
  ) as SectionState

  const ctx = useContext(PromoPageStateContext)

  const [localPromoState, setLocalPromoState] = useState<SectionState>(state)
  const [isVisible, setVisible] = useState(false)
  const [draggable, setDraggable] = useState(true)
  const [currentBlockIndex, setCurrentBlockIndex] = useState(0)

  const dragStartHandler = (e: DragEvent<HTMLDivElement>, oldIndex: number) => {
    setCurrentBlockIndex(oldIndex)
  }

  const dragLeaveHandler = (e: DragEvent<HTMLDivElement>) => {
    ;(e.target as HTMLDivElement).style.border = 'none'
  }

  const dragOverHandler = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    ;(e.target as HTMLDivElement).style.border = '2px solid #6449FF'
  }

  const dragDropHandler = (e: DragEvent<HTMLDivElement>, newIndex: number) => {
    e.preventDefault()
    ;(e.target as HTMLDivElement).style.border = 'none'

    const stateCopy = { ...localPromoState }
    const faqData = stateCopy.content as FaqData[]
    const oldElem = faqData.find((faq) => faq.index === currentBlockIndex)
    const newElem = faqData.find((faq) => faq.index === newIndex)

    oldElem!.index = newIndex
    newElem!.index = currentBlockIndex
    faqData.sort((a, b) => a.index - b.index)

    setLocalPromoState(stateCopy)
  }

  const faqElements = (localPromoState.content as FaqData[]).map((faq, index) => (
    <div
      key={faq.question}
      draggable={draggable}
      onDragStart={(e: DragEvent<HTMLDivElement>) => dragStartHandler(e, index)}
      onDragLeave={(e: DragEvent<HTMLDivElement>) => dragLeaveHandler(e)}
      onDragOver={(e: DragEvent<HTMLDivElement>) => dragOverHandler(e)}
      onDrop={(e: DragEvent<HTMLDivElement>) => dragDropHandler(e, index)}
    >
      <BlockWrap
        type={SectionName.faq}
        text={index + 1 + '. ' + faq.question}
        textFontSize={'14px'}
        setDraggable={setDraggable}
      >
        <FaqEl
          key={faq.question}
          index={index}
          localPromoState={localPromoState}
          setLocalPromoState={setLocalPromoState}
        />
      </BlockWrap>
    </div>
  ))

  const handleSave = () => {
    ctx.dispatch(saveSection(localPromoState))
  }

  const changeTitleHandler = (value: string) => {
    const state = { ...localPromoState }
    state.title = value
    setLocalPromoState(state)
  }

  const addFaqHandler = () => {
    const state = { ...localPromoState }
    ;(state.content as FaqData[]).push({
      question: '',
      answer: '',
      index: (state.content as FaqData[]).length,
      hrefText: '',
      href: '',
      target: '_blank',
    })
    setLocalPromoState(state)
  }

  return (
    <div className={s.faq}>
      <AdminInput label="Заголовок" labelWeight={600} value={localPromoState.title} onChange={changeTitleHandler} />

      <AdminElemVisibilityToggle text="Вопросы-ответы:" isVisible={isVisible} setVisible={setVisible} />

      {isVisible && (
        <>
          <div className={s.faqsWrap}>{faqElements}</div>
          <AdminAddElemButton text="Добавить вопрос-ответ" onClick={addFaqHandler} />
        </>
      )}

      <AdminSaveButton onClick={handleSave} />
    </div>
  )
}
